export const REJECT = {
  UNAUTHORIZED: 'unauthorized',
}
